export const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 228" preserveAspectRatio="xMidYMid meet">
  <path
    d="M133.2,3.98C105.52-3.89,77.15.27,53.73,13.32,30.31,26.37,11.84,48.31,3.98,75.99c-7.87,27.67-3.7,56.05,9.35,79.46,8.09,14.52,19.61,27.15,33.79,36.51l1.62-11.53c-10.9-8.08-19.85-18.37-26.34-30.03-11.76-21.1-15.51-46.66-8.43-71.58,7.08-24.92,23.73-44.68,44.83-56.44,21.1-11.76,46.66-15.52,71.58-8.43,24.92,7.08,44.68,23.72,56.44,44.83,8.22,14.76,13.23,34.42,11.87,52.48l10.34,1.45c1.25-20.96-4.05-42.66-13.15-58.98-13.05-23.42-34.99-41.89-62.66-49.76h0Z"
    fill="{{HEADER_LINKS_COLOR}}"
  />
  <text
    x="120"
    y="190"
    text-anchor="middle"
    fill="{{HEADER_LINKS_COLOR}}"
    font-family="Cinzel-Bold, Cinzel, Georgia, 'Times New Roman', serif"
    font-size="100"
    font-weight="700"
  >{{LOGO_INITIALS}}</text>
</svg>
`;
